import styled from 'styled-components';

export const DragAndDropFileAreaWrapper = styled.div<{ $isOver: boolean }>`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 1px dashed ${({ theme }): string => theme.admanColors!.gray.light.fg[4]};
  background: ${({ theme, $isOver }): string => ($isOver ? theme.admanColors!.gray.light.bg0[1] : 'transparent')};

  &:hover {
    background: ${({ theme }): string => theme.admanColors!.gray.light.bg0[1]};
  }

  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${({ theme }): string => theme.spacers!.spacer06};
    margin: ${({ theme }): string => theme.spacers!.spacer10};
  }
`;

export const HeaderWrapper = styled.header`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%;

  span {
    color: ${({ theme }): string => theme.admanColors!.blue.solid};
    cursor: pointer;
  }
`;

export const FileRequirementsWrapper = styled.header`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }): string => theme.spacers!.spacer08};
`;
